<template>
  <div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Type</th>
          <th scope="col">Name</th>
          <th scope="col">Reference</th>
          <th scope="col">Pax</th>
          <th scope="col">Travel date</th>
          <th scope="col">Status</th>
          <th scope="col">Created</th>
          <th scope="col">Options</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td scope="row"><span class="kt-badge kt-badge--danger kt-badge--inline kt-badge--pill">PDF</span> Quote</td>
          <td>Name of the quote</td>
          <td>CGTTUS01108</td>
          <td>20</td>
          <td>21 Aug 2020</td>
          <td>Quote</td>
          <td>23 Jun 2019</td>
          <td>
            <button class="btn btn-danger btn-block">Download</button>
          </td>
        </tr>
        <tr>
          <td scope="row"><span class="kt-badge kt-badge--primary kt-badge--inline kt-badge--pill">MsWord</span> Quote</td>
          <td>Name of the quote</td>
          <td>CGTTUS01108</td>
          <td>20</td>
          <td>21 Aug 2020</td>
          <td>Quote</td>
          <td>23 Jun 2019</td>
          <td>
            <button class="btn btn-danger btn-block">Download</button>
          </td>
        </tr>
        <tr>
          <td scope="row"><span class="kt-badge kt-badge--success kt-badge--inline kt-badge--pill">Link</span> Quote</td>
          <td>Name of the quote</td>
          <td>CGTTUS01108</td>
          <td>20</td>
          <td>21 Aug 2020</td>
          <td>Quote</td>
          <td>23 Jun 2019</td>
          <td>
            <button class="btn btn-danger btn-block">Link</button>
          </td>
        </tr>
      </tbody>
    </table>
    <nav class="mt-5">
      <ul class="pagination justify-content-center">
        <li class="page-item disabled">
          <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
        </li>
        <li class="page-item active"><a class="page-link" href="#">1</a></li>
        <li class="page-item"><a class="page-link" href="#">2</a></li>
        <li class="page-item"><a class="page-link" href="#">3</a></li>
        <li class="page-item">
          <a class="page-link" href="#">Next</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'QuotesTable'
}
</script>

<style lang="scss" scoped>
  .page-link {
    color: #cc0000 !important;
  }
  .page-item.disabled .page-link {
    color: #6c757d !important;
  }
  .page-item.active .page-link {
    background-color: #cc0000 !important;
    border-color: #cc0000 !important;
    color: #fff !important;
  }
</style>
